import { Component, OnInit, OnDestroy, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { Subscription } from 'rxjs';
import { ReportsHelpbuttonService } from 'src/app/services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';

@Component({
  selector: 'app-helpbutton-reports-all-card',
  templateUrl: './helpbutton-reports-all-card.component.html',
  styleUrls: ['./helpbutton-reports-all-card.component.scss']
})
export class HelpbuttonReportsAllCardComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() data;
  count;
  showCounter: boolean;
  refreshAssistancesListSubscription: Subscription;

  constructor(private reportsService: ReportsHelpbuttonService,
            private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('reports-all-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('reports-all-spinner');
      this.showCounter = true;
      this.count = this.data;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
    }
  }

  ngOnDestroy() {
    if (this.refreshAssistancesListSubscription) { this.refreshAssistancesListSubscription.unsubscribe(); }
  }

}
